var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRapid7Color({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7232 11.5H9.1944C9.55024 11.8514 9.84679 12.1442 10.1433 12.5542C12.575 15.4241 13.8204 19.0553 13.8204 23.038C13.8204 29.1876 11.2109 34.7516 7 38.5H20.1664L26.453 23.1551H18.6244L19.9292 17.1811H35.4679L27.2833 38.4415H30.486C37.9588 38.5 43 32.3504 43 24.9707C43 17.5911 38.196 11.5 30.7232 11.5Z",
    fill: "#E95F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapid7Color);
export default __webpack_public_path__ + "static/media/rapid_7_color.dc0f6262b14f065d9cb746fdf6ee400b.svg";
export { ForwardRef as ReactComponent };